import { useAddInstViaSystemUserPages } from '../../api';

import { AddButton } from '@/components';
import { Departments } from '@/types';

type Props = {
  isLoading: boolean;
  department: Departments;
};

export const AddInstViaSystemUserPagesButton = ({ isLoading, department }: Props) => {
  const addInstPages = useAddInstViaSystemUserPages();

  return (
    <AddButton
      isLoading={isLoading || addInstPages.isLoading}
      onClick={() => addInstPages.mutate({ department })}
      text="FACEBOOK CONNECT"
    />
  );
};
